export function formatTitleForUrl(projectTitle) {
    return projectTitle.toLowerCase().replace(/\s+/g, "-");
}